import { CommentCategory } from "../report/CommentCategory";

export type EstimatedBehaviorCategory = {
    key: string,
    label: string,
    commentCategories: CommentCategory[]
};

const Sleep: EstimatedBehaviorCategory = {
    key: "sleep",
    label: "睡眠",
    commentCategories: [
        CommentCategory?.NIGHTLY_SLEEP_COUNT,
        CommentCategory?.NIGHTLY_SLEEP_TIME,
        CommentCategory?.DAILY_SLEEP,
        CommentCategory?.DAILY_SLEEP_COUNT,
    ],
};

const Toilet: EstimatedBehaviorCategory = {
    key: "toilet",
    label: "トイレ",
    commentCategories: [
        CommentCategory?.NIGHTLY_TOILET_COUNT,
        CommentCategory?.TOILET_COUNT,
        CommentCategory?.TOILET_TIME,
    ],
};

const Bath: EstimatedBehaviorCategory = {
    key: "bath",
    label: "入浴",
    commentCategories: [
        CommentCategory?.BATH_COUNT,
        CommentCategory?.BATH_TIME,
    ],
};

const Meal: EstimatedBehaviorCategory = {
    key: "meal",
    label: "調理準備",
    commentCategories: [
        CommentCategory?.MEAL_COUNT,
        CommentCategory?.MEAL_TIME,
    ],
};

const Laundry: EstimatedBehaviorCategory = {
    key: "laundry",
    label: "洗濯",
    commentCategories: [
        CommentCategory?.LAUNDRY_COUNT,
        CommentCategory?.LAUNDRY_TIME,
        CommentCategory?.NIGHTLY_LAUNDRY,
    ],
};

const Sweeping: EstimatedBehaviorCategory = {
    key: "sweeping",
    label: "掃除",
    commentCategories: [
        CommentCategory?.SWEEPING_COUNT,
        CommentCategory?.SWEEPING_TIME,
        CommentCategory?.NIGHTLY_SWEEPING,
    ],
};

const GoingOut: EstimatedBehaviorCategory = {
    key: "goingOut",
    label: "外出",
    commentCategories: [],
};

const Tv: EstimatedBehaviorCategory = {
    key: "tv",
    label: "テレビ",
    commentCategories: [
        CommentCategory?.TV_TIME,
        CommentCategory?.NIGHTLY_TV,
    ],
};

export const EstimatedBehaviorCategories = {
    SLEEP: Sleep,
    TOILET: Toilet,
    BATH: Bath,
    MEAL: Meal,
    LAUNDRY: Laundry,
    SWEEPING: Sweeping,
    GOING_OUT: GoingOut,
    TV: Tv,
};

export const EstimatedBehaviorCategoryList: readonly EstimatedBehaviorCategory[] = [
    Sleep,
    Toilet,
    Bath,
    Meal,
    Laundry,
    Sweeping,
    Tv,
];
